export * from './lib/video-player.module';
export * from './lib/video-player.component';
export * from './lib/controls';
export * from './lib/video-playback.service';
export * from './lib/video-player.reference';
export * from './lib/services';
export * from './lib/references/players.reference.constants';
